'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dKind from "./app.data.-App-Document-Kind.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm() {
}
export { $c_Lapp_data_AppDocumentDataForm as $c_Lapp_data_AppDocumentDataForm };
$p = $c_Lapp_data_AppDocumentDataForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataForm;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm() {
}
export { $h_Lapp_data_AppDocumentDataForm as $h_Lapp_data_AppDocumentDataForm };
$h_Lapp_data_AppDocumentDataForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.ur = (function() {
  if ((this instanceof $c_Lapp_data_AppDocumentDataForm$PurchaseOrder)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind();
  }
  if ((this instanceof $c_Lapp_data_AppDocumentDataForm$Invoice)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind();
  }
  if ((this instanceof $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind();
  }
  if ((this instanceof $c_Lapp_data_AppDocumentDataForm$CreditNote)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind();
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
function $isArrayOf_Lapp_data_AppDocumentDataForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dD)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataForm as $isArrayOf_Lapp_data_AppDocumentDataForm };
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin(data) {
  this.XB = null;
  this.XB = data;
}
export { $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin as $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin };
$p = $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin.prototype = new $h_Lapp_data_AppDocumentDataForm();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin() {
}
export { $h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin as $h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin };
$h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin)) {
    var x = this.XB;
    var x$2 = x$0.XB;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "CertificateOfOrigin";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.XB;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 2;
});
function $isArrayOf_Lapp_data_AppDocumentDataForm$CertificateOfOrigin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iU)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataForm$CertificateOfOrigin as $isArrayOf_Lapp_data_AppDocumentDataForm$CertificateOfOrigin };
var $d_Lapp_data_AppDocumentDataForm$CertificateOfOrigin = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin, "app.data.AppDocumentDataForm$CertificateOfOrigin", ({
  iU: 1,
  dD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$CertificateOfOrigin as $d_Lapp_data_AppDocumentDataForm$CertificateOfOrigin };
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$CreditNote(data) {
  this.XC = null;
  this.XC = data;
}
export { $c_Lapp_data_AppDocumentDataForm$CreditNote as $c_Lapp_data_AppDocumentDataForm$CreditNote };
$p = $c_Lapp_data_AppDocumentDataForm$CreditNote.prototype = new $h_Lapp_data_AppDocumentDataForm();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$CreditNote;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$CreditNote() {
}
export { $h_Lapp_data_AppDocumentDataForm$CreditNote as $h_Lapp_data_AppDocumentDataForm$CreditNote };
$h_Lapp_data_AppDocumentDataForm$CreditNote.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataForm$CreditNote)) {
    var x = this.XC;
    var x$2 = x$0.XC;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "CreditNote";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.XC;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 3;
});
function $isArrayOf_Lapp_data_AppDocumentDataForm$CreditNote(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iV)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataForm$CreditNote as $isArrayOf_Lapp_data_AppDocumentDataForm$CreditNote };
var $d_Lapp_data_AppDocumentDataForm$CreditNote = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$CreditNote, "app.data.AppDocumentDataForm$CreditNote", ({
  iV: 1,
  dD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$CreditNote as $d_Lapp_data_AppDocumentDataForm$CreditNote };
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$Invoice(data) {
  this.XD = null;
  this.XD = data;
}
export { $c_Lapp_data_AppDocumentDataForm$Invoice as $c_Lapp_data_AppDocumentDataForm$Invoice };
$p = $c_Lapp_data_AppDocumentDataForm$Invoice.prototype = new $h_Lapp_data_AppDocumentDataForm();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$Invoice;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$Invoice() {
}
export { $h_Lapp_data_AppDocumentDataForm$Invoice as $h_Lapp_data_AppDocumentDataForm$Invoice };
$h_Lapp_data_AppDocumentDataForm$Invoice.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataForm$Invoice)) {
    var x = this.XD;
    var x$2 = x$0.XD;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Invoice";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.XD;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_AppDocumentDataForm$Invoice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iW)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataForm$Invoice as $isArrayOf_Lapp_data_AppDocumentDataForm$Invoice };
var $d_Lapp_data_AppDocumentDataForm$Invoice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$Invoice, "app.data.AppDocumentDataForm$Invoice", ({
  iW: 1,
  dD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$Invoice as $d_Lapp_data_AppDocumentDataForm$Invoice };
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$PurchaseOrder(data) {
  this.XE = null;
  this.XE = data;
}
export { $c_Lapp_data_AppDocumentDataForm$PurchaseOrder as $c_Lapp_data_AppDocumentDataForm$PurchaseOrder };
$p = $c_Lapp_data_AppDocumentDataForm$PurchaseOrder.prototype = new $h_Lapp_data_AppDocumentDataForm();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$PurchaseOrder;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$PurchaseOrder() {
}
export { $h_Lapp_data_AppDocumentDataForm$PurchaseOrder as $h_Lapp_data_AppDocumentDataForm$PurchaseOrder };
$h_Lapp_data_AppDocumentDataForm$PurchaseOrder.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataForm$PurchaseOrder)) {
    var x = this.XE;
    var x$2 = x$0.XE;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "PurchaseOrder";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.XE;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 0;
});
function $isArrayOf_Lapp_data_AppDocumentDataForm$PurchaseOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iX)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataForm$PurchaseOrder as $isArrayOf_Lapp_data_AppDocumentDataForm$PurchaseOrder };
var $d_Lapp_data_AppDocumentDataForm$PurchaseOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$PurchaseOrder, "app.data.AppDocumentDataForm$PurchaseOrder", ({
  iX: 1,
  dD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$PurchaseOrder as $d_Lapp_data_AppDocumentDataForm$PurchaseOrder };
//# sourceMappingURL=app.data.-App-Document-Data-Form.js.map
